import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {PopupComponent} from '../popup/popup.component';
import {ConfigService} from '../config/config.service';
import {UntypedFormControl, UntypedFormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import { HttpHeaders } from '@angular/common/http';
import { Output, EventEmitter } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import {backendAddress} from '../../environments/environment';
import {LanguageService} from '../service/language.service';

@Component({
    selector: 'app-add-art',
    templateUrl: './add-art.component.html',
    styleUrls: ['./add-art.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AddArtComponent implements OnInit {
  @Input() isEditArtVisible: any;
  @Input() artObjectFromEdit: any;
  @Output() newItemEvent = new EventEmitter<string>();
  @Input() loggedInUser: any;

  constructor(public dialog: MatDialog, private api: ConfigService, private snackBar: MatSnackBar,
              // tslint:disable-next-line:variable-name
              private translate: TranslateService, private _language: LanguageService) {
    this._language.current_lang.subscribe(lang => {
      if (lang === 0 ) {
        translate.use('ro');
      } else {
        translate.use('en');
      }
    });
  }


  artObjects = [
    {
      id: 0,
      image: {
        name: ''
      },
      title: '',
      description: '',
      category: '1',
      availability: '0',
      dimension: '',
      technique: '',
      year: '',
      price: 0
    }
  ];
  imgEditArtPath = '';
  categories = [
    {
      id: 0,
      name: '',
    },
  ];
  availabilities = [
    {
      id: 0,
      name: 'available'
    },
    {
      id: 1,
      name: 'onOrder'
    }
  ];
  filedata: any;
  isLoaderVisible = false;
  receiverdId = 0;
  errorMessage = '';
  canAddArt = true;
  backendAddress = backendAddress.value;
  isDataReady = false;
  imageSizeError = false;

  // tslint:disable-next-line:typedef
  addArtForm = new UntypedFormGroup({
    title: new UntypedFormControl('', [Validators.required]),
    description: new UntypedFormControl('', [Validators.required]),
    category: new UntypedFormControl('', [Validators.required]),
    availability: new UntypedFormControl('', [Validators.required]),
    dimension: new UntypedFormControl('', [Validators.required]),
    technique: new UntypedFormControl('', [Validators.required]),
    year: new UntypedFormControl('', [Validators.required, Validators.pattern(/^\d{4}$/)]),
    price: new UntypedFormControl('', [Validators.required, Validators.pattern( /^\d+$/)]),
  });

  // tslint:disable-next-line:typedef
  get titleFormControl() {
    return this.addArtForm.get('title') as UntypedFormControl;
  }

  // tslint:disable-next-line:typedef
  get descriptionFormControl() {
    return this.addArtForm.get('description') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get categoryFormControl() {
    return this.addArtForm.get('category') as UntypedFormControl;
  }

  // tslint:disable-next-line:typedef
  get availabilityFormControl() {
    return this.addArtForm.get('availability') as UntypedFormControl;
  }

  // tslint:disable-next-line:typedef
  get dimensionFormControl() {
    return this.addArtForm.get('dimension') as UntypedFormControl;
  }

  // tslint:disable-next-line:typedef
  get techniqueFormControl() {
    return this.addArtForm.get('technique') as UntypedFormControl;
  }

  // tslint:disable-next-line:typedef
  get yearFormControl() {
    return this.addArtForm.get('year') as UntypedFormControl;
  }

  // tslint:disable-next-line:typedef
  get priceFormControl() {
    return this.addArtForm.get('price') as UntypedFormControl;
  }


  // tslint:disable-next-line:typedef
  checkFile(fileName: string) {
    return !!fileName;
  }

  // onSubmitform(f: ReactiveFormsModule) {
  //   if (this.checkYear()){
  //     if (this.verifyForm()){
  //       this.errorMessage = '';
  //       const myFormData = new FormData();
  //       const headers = new HttpHeaders();
  //       headers.append('Content-Type', 'multipart/form-data');
  //       headers.append('Accept', 'application/json');
  //       myFormData.append('painting', this.filedata);
  //       myFormData.append('title', this.artObjects[0].title);
  //       myFormData.append('description', this.artObjects[0].description);
  //       myFormData.append('picture_category_id', this.artObjects[0].category);
  //       myFormData.append('availability', this.artObjects[0].availability);
  //       myFormData.append('dimension', this.artObjects[0].dimension);
  //       myFormData.append('technique', this.artObjects[0].technique);
  //       myFormData.append('year', this.artObjects[0].year);
  //       if (this.artObjects[0].id) {
  //         myFormData.append('id', this.artObjects[0].id.toString());
  //       }
  //       this.isLoaderVisible = true;
  //       this.api.postFile(myFormData).subscribe(data => {
  //           this.isLoaderVisible = false;
  //           window.location.reload();
  //           this.translate.get('uploadSuccessful').subscribe(message => {
  //             this.snackBar.open(message, '',
  //               {duration: 3000, panelClass: 'success-snack-bar',
  //                 horizontalPosition: 'end', verticalPosition: 'top'});
  //           });
  //         },
  //         error => {
  //           this.isLoaderVisible = false;
  //           console.log('error', error);
  //           this.translate.get('errorOccurred').subscribe(message => {
  //             this.snackBar.open(message, '',
  //               {duration: 3000, panelClass: 'error-snack-bar',
  //                 horizontalPosition: 'end', verticalPosition: 'top'});
  //           });
  //         });
  //     }
  //     else {
  //       this.translate.get('completeRequiredFields').subscribe(message => {
  //         this.errorMessage = message;
  //       });
  //     }
  //   }
  // }

  // tslint:disable-next-line:typedef
  onSubmitform2(fileName: string) {
    if (this.checkFile(fileName)) {
      const addArtFormData = new FormData();
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');
      addArtFormData.append('painting', this.filedata);
      addArtFormData.append('title', this.titleFormControl.value);
      addArtFormData.append('description', this.descriptionFormControl.value);
      addArtFormData.append('picture_category_id', this.categoryFormControl.value);
      addArtFormData.append('availability', this.availabilityFormControl.value);
      addArtFormData.append('dimension', this.dimensionFormControl.value);
      addArtFormData.append('technique', this.techniqueFormControl.value);
      addArtFormData.append('year', this.yearFormControl.value);
      addArtFormData.append('price', this.priceFormControl.value);

      // addArtFormData.append('id', this.artObjects[0].id.toString());
      console.log('willsend', addArtFormData);

      // @ts-ignore
      for (const value of addArtFormData.entries()) {
        console.log('valuee', value);
      }
      if (this.artObjects[0].id) {
        addArtFormData.append('id', this.artObjects[0].id.toString());
      }
      this.isLoaderVisible = true;
      this.api.postFile(addArtFormData).subscribe(data => {
          this.isLoaderVisible = false;
          window.location.reload();
          this.translate.get('uploadSuccessful').subscribe(message => {
            this.snackBar.open(message, '',
              {
                duration: 3000, panelClass: 'success-snack-bar',
                horizontalPosition: 'end', verticalPosition: 'top'
              });
          });
        },
        error => {
          this.isLoaderVisible = false;
          console.log('error', error);
          this.translate.get('errorOccurred').subscribe(message => {
            this.snackBar.open(message, '',
              {
                duration: 3000, panelClass: 'error-snack-bar',
                horizontalPosition: 'end', verticalPosition: 'top'
              });
          });
        });
    } else {
      this.translate.get('noArt').subscribe(message => {
        this.errorMessage = message;
      });
    }
  }

  cancelEdit(): void {
    this.newItemEvent.emit('cancel-edit');
  }
  deleteImage(artObject: any): void {
    this.artObjects.forEach(element => {
      if ( element === artObject ){
        // @ts-ignore
        artObject.image =  {name: ''};
      }
    });
  }
  openDialogDeleteImage(artObject: any): void {
    this.translate.get('sureYouWantToDelete').subscribe(message => {
      const dialogRef = this.dialog.open(PopupComponent, {
        data: {popupText: message, popupButtonsNotVsible: 'nu'},
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result === true){
          this.deleteImage(artObject);
        }
      });
    });
  }


  // openDialogFieldsRequired(): void {
  //   this.dialog.open(PopupComponent, {
  //    data: {popupText: 'Trebuie sa completezi campurile obligatorii prima data si poi poti adauga un obiect nou',
  //    popupButtonsNotVsible: 'da'},
  //     disableClose: true
  //   });
  // }

  // tslint:disable-next-line:typedef
  // fileEvent(artObject: any, e: Event){
  //   // @ts-ignore
  //   this.filedata = e.target.files[0];
  //   this.artObjects.forEach(element => {
  //     if ( element === artObject ){
  //       // @ts-ignore
  //       artObject.image =  e.target.files[0];
  //       console.log('art object', artObject.image);
  //     }
  //   });
  // }


  // tslint:disable-next-line:typedef
  fileEvent(artObject: any, e: Event) {
    const input = e.target as HTMLInputElement;
    if (!input.files?.length) { return; }
    const file = input.files[0];
    const reader = new FileReader();
    reader.onload = (event: any) => {
      const img = new Image();
      img.src = event.target.result;

      img.onload = () => {
        const width = img.width;
        const height = img.height;

        console.log('Image dimensions:', width, 'x', height);

        if (width > 1000 || height > 1000) {
          this.imageSizeError = true;
          return;
        }

        this.filedata = file;
        this.imageSizeError = false;
        this.artObjects.forEach(element => {
          if (element === artObject) {
            artObject.image = file;
            console.log('art object', artObject.image);
          }
        });
      };
    };

    reader.readAsDataURL(file);
  }

  // addArt(): void {
  //   if (this.artObjects[this.artObjects.length - 1].description === '' || this.artObjects[this.artObjects.length - 1].title === ''){
  //     this.openDialogFieldsRequired();
  //   } else {
  //     this.artObjects.push({
  //       id: this.artObjects[this.artObjects.length - 1].id + 1,
  //       image: {
  //         name: ''
  //       },
  //       title: '',
  //       description: '',
  //       category: '1',
  //       availability: '1',
  //       dimension: '',
  //       technique: '',
  //       year: '',
  //       price: 0
  //     });
  //   }
  // }


  getUpsertDropdowns(): void {
    this.isLoaderVisible = true;
    this.api.postUpsertDropdowns().subscribe(data => {
      // @ts-ignore
      this.categories = data.painting_categories;
      this.isLoaderVisible = false;
    }, err => {
      this.isLoaderVisible = false;
    });
  }
  checkAddAvailability(): void {
    this.isLoaderVisible = true;
    this.api.getLoggedInArtistArtObjects().subscribe(data => {
        // @ts-ignore
        const addedArt = data.length;
        if (addedArt >= 5) {
          this.canAddArt = false;
        }
        this.isLoaderVisible = false;
        this.isDataReady = true;
        this.getUpsertDropdowns();
      },
      error => {
        console.log('error', error);
        this.isLoaderVisible = false;
        this.isDataReady = true;
        this.translate.get('errorOccurred').subscribe(message => {
          this.snackBar.open(message, '',
            {duration: 3000, panelClass: 'error-snack-bar',
              horizontalPosition: 'end', verticalPosition: 'top'});
        });
      });
  }
  async createEditArtObject(): Promise<void> {
    if (this.artObjectFromEdit != null) {
      this.receiverdId = this.artObjectFromEdit.id;
      this.artObjects[0] = {
        id: this.artObjectFromEdit.id,
        image: {
          name: this.artObjectFromEdit.file_name,
        },
        title: this.artObjectFromEdit.title,
        description: this.artObjectFromEdit.description,
        category: this.artObjectFromEdit.picture_category_id,
        availability: this.artObjectFromEdit.availability,
        dimension: this.artObjectFromEdit.dimension,
        technique: this.artObjectFromEdit.technique,
        year: this.artObjectFromEdit.year,
        price: this.artObjectFromEdit.price
      };
      this.titleFormControl.setValue(this.artObjectFromEdit.title);
      this.descriptionFormControl.setValue(this.artObjectFromEdit.description);
      this.categoryFormControl.setValue(this.artObjectFromEdit.picture_category_id);
      this.availabilityFormControl.setValue(this.artObjectFromEdit.availability);
      this.dimensionFormControl.setValue(this.artObjectFromEdit.dimension);
      this.techniqueFormControl.setValue(this.artObjectFromEdit.technique);
      this.yearFormControl.setValue(this.artObjectFromEdit.year);
      this.priceFormControl.setValue(this.artObjectFromEdit.price);
      this.imgEditArtPath = this.artObjectFromEdit.file_path;
      this.imgEditArtPath = this.artObjectFromEdit.file_path;
    }
    await this.getUpsertDropdowns();
  }
  ngOnInit(): void {
    if (this.loggedInUser.role_id !== 3) {
      if (!this.isEditArtVisible) {
        this.checkAddAvailability();
      } else {
        this.createEditArtObject().then(() => {
          this.isDataReady = true;
          console.log('edit art', this.artObjectFromEdit);
        });
      }
    } else {
      this.isDataReady = true;
    }
  }
}
